import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable, of, ReplaySubject } from 'rxjs';
import {
    catchError,
    distinctUntilChanged,
    filter,
    map,
    skip,
    take,
    takeWhile,
    tap
} from 'rxjs/operators';
import * as fromDataServices from '../../../data-services';
import { Message, ToastMessageOptions } from '../../../shared';
import { UnsavedChangesService } from '../../../shared/modal-dialog';
import { LoggingService } from '../../../shared/services/logging';
import { ToasterService } from '../../../toaster';

@Component({
    selector: 'ef-indirect-rate-review-container',
    templateUrl: './indirect-rate-review-container.component.html',
    styleUrls: ['./indirect-rate-review-container.component.scss'],
    standalone: false
})
export class IndirectRateReviewContainerComponent
    implements OnInit, AfterViewInit, OnChanges
{
    IndirectRateReviewModelDS: EntityCollectionService<fromDataServices.IndirectRateReview.IndirectRateReviewModel>;
    IndirectRateReviewModel$: Observable<
        fromDataServices.IndirectRateReview.IndirectRateReviewModel[]
    >;
    jobTimerDataService: EntityCollectionService<fromDataServices.JobTimer.JobTimerModel>;
    IndirectRateAdjustDataService: EntityCollectionService<fromDataServices.IndirectRateAdjust.IndirectRateAdjust>;
    private jobTimerName = 'ef_indirectratesadjust_apply';
    jobTimer$: Observable<boolean>;
    @Input() fiscalYear;
    @Input() refresh: boolean;
    @Output() Cancel = new EventEmitter();
    MessagesSubject = new ReplaySubject<ToastMessageOptions[]>(1);
    active = true;

    @Output() SetProcessingText = new ReplaySubject<any>();

    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private confirmService: UnsavedChangesService,
        private toaster: ToasterService
    ) {
        this.log.verbose({ type: 'IndirectRateReviewContainerComponent::' });
        this.IndirectRateReviewModelDS =
            entityServices.getEntityCollectionService<fromDataServices.IndirectRateReview.IndirectRateReviewModel>(
                fromDataServices.IndirectRateReview.entityName
            );
        this.jobTimerDataService =
            entityServices.getEntityCollectionService<fromDataServices.JobTimer.JobTimerModel>(
                fromDataServices.JobTimer.entityName
            );
        this.IndirectRateAdjustDataService =
            entityServices.getEntityCollectionService<fromDataServices.IndirectRateAdjust.IndirectRateAdjust>(
                fromDataServices.IndirectRateAdjust.entityName
            );

        this.jobTimer$ = this.jobTimerDataService.entities$.pipe(
            map(items =>
                items.find(item => item.Jobdesc === sessionStorage.getItem('jobTimerName'))
            ),
            map(item => (item ? item : { Timer: false })),
            map(item => item.Timer),
            tap(jobTimer => {
                this.log.verbose({
                    type: 'IndirectRateReviewContainerComponent:jobTimer$',
                    jobTimer
                });
            }),
            distinctUntilChanged()
        );
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.log.verbose({
            type: 'IndirectRateReviewContainerComponent:ngOnChanges',
            changes
        });
        if (changes.refresh && changes.refresh.currentValue === true) {
            this.loadRateAdjustment(this.fiscalYear);
            // } else {
            //     if (changes.fiscalYear && changes.fiscalYear.currentValue) {
            //         this.loadRateAdjustment(changes.fiscalYear.currentValue);
            //     }
        }
    }
    loadRateAdjustment(fiscalYear) {
        sessionStorage.setItem('jobTimerName', 'ef_indirectratesadjust_apply');
        this.SetProcessingText.next('Processing Rate Adjustment');
        this.IndirectRateReviewModelDS.clearCache();
        this.IndirectRateReviewModelDS.getWithQuery({
            FYenddate: fiscalYear,
            RateAdjustStep: 'RA'
        });
        this.IndirectRateReviewModel$ = this.IndirectRateReviewModelDS.entities$;
        this.jobTimer$
            .pipe(
                filter(x => !x),
                skip(1),
                take(1)
            )
            .subscribe(jobTimer => {
                this.log.verbose({
                    type: 'IndirectRateReviewContainerComponent:loadRateAdjustment:jobTimer$',
                    jobTimer
                });
                this.IndirectRateReviewModelDS.clearCache();
                this.IndirectRateReviewModelDS.getWithQuery({
                    FYenddate: fiscalYear,
                    RateAdjustStep: 'RA'
                }).pipe(take(1)).subscribe(items => {
                    this.IndirectRateReviewModel$ =
                        this.IndirectRateReviewModelDS.entities$;
                })
            });
    }

    commitRateAdjustment(fiscalYear) {
        this.IndirectRateReviewModel$ =
                this.IndirectRateReviewModelDS.entities$;
        this.SetProcessingText.next('Committing Rate Adjustment');
        sessionStorage.setItem('jobTimerName', 'ef_indirectrateadjust_rebuildYTD_andforward');
        this.IndirectRateReviewModelDS.clearCache();
        this.IndirectRateReviewModelDS.getWithQuery({
            FYenddate: fiscalYear,
            RateAdjustStep: 'A'
        });
        this.jobTimer$
            .pipe(
                filter(x => !x),
                skip(1),
                take(1)
            )
            .subscribe(jobTimer => {
                this.log.verbose({
                    type: 'IndirectRateReviewContainerComponent:loadRateAdjustment:jobTimer$',
                    jobTimer
                });
                this.IndirectRateAdjustDataService.clearCache();
                this.IndirectRateAdjustDataService.getWithQuery({
                    FYenddate: fiscalYear,
                    RateAdjustStep: 'A'
                })
                    .pipe(
                        take(1),
                        catchError(err => {
                            this.toaster.pop({
                                type: 'error',
                                title: 'Error',
                                body: err.message
                            });
                            return of(null);
                        })
                    )
                    .subscribe(items => {
                        if (items) {
                            this.IndirectRateReviewModel$ = this.IndirectRateAdjustDataService.entities$;
                            this.MessagesSubject.next([
                                {
                                    severity: 'success',
                                    summary: 'Success',
                                    detail: 'Rate adjustment entries have been committed.'
                                }
                            ]);
                        }
                    });
            });
    }
    ngOnInit(): void {}
    ngAfterViewInit(): void {
        setTimeout(() => {


            // .pipe(
            //     map(items => [{ id: 'add' }, ...clone(items)])
            // );
        }, 0);
    }
    ngOnDestroy() {
        this.active = false;
    }
    onCancel(): void {
        this.IndirectRateReviewModelDS.getWithQuery({
            FYenddate: this.fiscalYear,
            RateAdjustStep: 'C'
        });
        this.Cancel.next();
    }
    onCommit(): void {
        this.commitRateAdjustment(this.fiscalYear);
        // this.IndirectRateReviewModelDS.getWithQuery({
        //     FYenddate: this.fiscalYear,
        //     RateAdjustStep: 'A'
        // })
        //     .pipe(
        //         take(1),
        //         catchError(err => {
        //             this.toaster.pop({
        //                 type: 'error',
        //                 title: 'Error',
        //                 body: err.message
        //             });
        //             return of(null);
        //         })
        //     )
        //     .subscribe(items => {
        //         if (items) {
        //             this.MessagesSubject.next([
        //                 {
        //                     severity: 'success',
        //                     summary: 'Success',
        //                     detail: 'Rate adjustment entries have been committed.'
        //                 }
        //             ]);
        //         }
        //     });
    }
}
